import React from 'react';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { reduxForm } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { categories } from '../categories/_api';
import { get } from 'lodash';
import { addItemToReservation, confirmAddItemToReservation } from './_api';
import withLoader from '../app/withLoader';
import { Autocomplete } from '../../components/forms/Autocomplete';
import withCountPriceServeItem from './withCountPriceServeItem';

const enhance = compose(
  withLoader,
  withCountPriceServeItem,
  withState('categories', 'setCategories', []),
  withState('items', 'setItems', []),
  lifecycle({
    async componentDidMount() {
      const { toggleLoader, setCategories } = this.props;
      toggleLoader();
      const resp = await categories();
      if (resp) {
        setCategories(resp.items);
      }
      toggleLoader(false);
    },
  }),
  withHandlers({
    onSubmit:
      ({ toggleLoader, items, item, setAddItemDialog, loadItem }) =>
      async (values) => {
        toggleLoader();
        const data = {
          reservationId: item.id,
          item: {
            from: items.from,
            to: items.to,
            requestId: items.requestId,
            personId: items.personId,
            itemId: get(values, 'item.id'),
            price: get(values, 'item.price'),
          },
        };
        const resp = await confirmAddItemToReservation(data);
        if (get(resp, 'success')) {
          setAddItemDialog({ open: false, title: '' });
          await loadItem(item.id);
        }
        toggleLoader(false);
      },
    loadItems:
      ({ item, toggleLoader, addItemDialog, setItems, serveItems, countDays }) =>
      async (id) => {
        toggleLoader();
        const daysCount = countDays(item.from, item.to);
        const values = {
          reservationId: item.id,
          item: {
            requestId: id.toLowerCase(),
            categoryId: id,
            personId: parseInt(addItemDialog.personId, 10),
            from: item.from,
            to: item.to,
            filters: [],
          },
        };
        const resp = await addItemToReservation(values);
        const catId = get(Object.keys(get(resp, 'data.items', {})), '[0]');
        const itemsToShow = get(resp, `data.items.${catId}`, {});
        const items = serveItems(itemsToShow, null, daysCount);
        setItems({
          items,
          requestId: get(itemsToShow, 'requestServerUid'),
          personId: parseInt(addItemDialog.personId, 10),
          from: item.from,
          to: item.to,
        });
        toggleLoader(false);
      },
  }),

  reduxForm({ form: 'addItem' })
);

export default enhance(
  ({ addItemDialog, setAddItemDialog, fullScreen, handleSubmit, categories, items, loadItems }) => (
    <form onSubmit={handleSubmit}>
      <Dialog
        fullScreen={fullScreen}
        open={addItemDialog.open}
        onClose={() => setAddItemDialog({ open: false, title: '' })}
        aria-labelledby="responsive-dialog-title"
        style={{
          minWidth: 400,
          width: '80%',
          minHeight: '80vh',
          maxHeight: '80vh',
        }}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">Přidat položku do rezervace</DialogTitle>
        <DialogContent style={{ minHeight: '500px', overflow: 'hidden' }}>
          <Grid container={true} spacing={16}>
            <Grid item={true} xs={12} md={12} lg={12}>
              <Autocomplete
                name="category"
                label={addItemDialog.title}
                options={categories.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                onChange={(e, value) => loadItems(get(value, 'value'))}
              />
            </Grid>
            <Grid item={true} xs={12} md={12} lg={12}>
              <Autocomplete
                name="item"
                label={addItemDialog.title}
                options={get(items, 'items', []).map((item) => ({
                  ...item,
                  value: item.id,
                  label: `${item.label}, ${item.price} Kč`,
                }))}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            autoFocus
          >
            Uložit
          </Button>
          <Button
            onClick={() => setAddItemDialog({ open: false, title: '' })}
            color="secondary"
            variant="contained"
          >
            Zrušit
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/addItemDialog.js